import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 13.5c0 1.86.76 3.55 1.98 4.77A6.735 6.735 0 0011 20.25h6.25c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.75 1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-7.68c-.38 0-.63-.42-.43-.75l1.73-3A1.501 1.501 0 009.27 3l-4.15 7.2c-.56.97-.87 2.1-.87 3.3zm0 0c0 3.73 3.02 6.75 6.75 6.75"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 13.5c0 1.86.76 3.55 1.98 4.77A6.735 6.735 0 0011 20.25h6.25c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.75 1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-7.68c-.38 0-.63-.42-.43-.75l1.73-3A1.501 1.501 0 009.27 3l-4.15 7.2c-.56.97-.87 2.1-.87 3.3zm0 0c0 3.73 3.02 6.75 6.75 6.75"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M8.5 27c0 3.72 1.52 7.1 3.96 9.54A13.47 13.47 0 0022 40.5h12.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H21.14c-.76 0-1.26-.84-.86-1.5l3.46-6c.82-1.44.34-3.26-1.1-4.1-1.44-.82-3.28-.34-4.1 1.1l-8.3 14.4C9.12 22.34 8.5 24.6 8.5 27zm0 0c0 7.46 6.04 13.5 13.5 13.5"
  }))
};
export var ThumbsUp = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});